const common = {
  // Header
  "header.english": "English",
  "header.francais": "Français",
  "header.searchPlaceholder": "Rechercher…",
  "header.searchAria": "Rechercher",
  "header.submitSearch": "Lancer la recherche",
  "header.trustees": "Fiduciaires",
  "header.memberLogin": "Connexion membre",
  "header.decreaseFont": "Réduire la taille du texte",
  "header.increaseFont": "Augmenter la taille du texte",

  // Navbar
  "nav.home": "Accueil",
  "nav.aboutTheFund": "À propos de la Caisse",
  "nav.summaryPlan": "Résumé du régime",
  "nav.planRules": "Règles du régime",
  "nav.resources": "Ressources",
  "nav.news": "Actualités",
  "nav.faq": "FAQ",
  "nav.member": "Membre",
  "nav.contactUs": "Nous joindre",
  "nav.mobileTitle": "Navigation",
  "nav.toggleAria": "Basculer la navigation",

  // Navbar dropdown
  "nav.annualReports": "Rapports annuels",
  "nav.newsletters": "Bulletins d'information",
  "nav.forms": "Formulaires",
  "nav.whatHappensIf": "Qu'arrive-t-il si?",
  "nav.thingsYouNeedToKnow": "Ce que vous devez savoir",
  "nav.miscellaneous": "Divers",
  "nav.links": "Liens",
  "nav.rrspComparisons": "Comparaisons REER",
  "nav.someppNotice": "Avis SOMEPP",
  "nav.keyPlanDefinitions": "Comprendre les définitions clés du régime",

  // Footer
  "footer.tagline": "Administration des prestations de retraite pour les musiciens et bénéficiaires admissibles partout au Canada.",
  "footer.thePlan": "LE RÉGIME",
  "footer.aboutTheFund": "À propos de la Caisse",
  "footer.summaryPlan": "Résumé du régime",
  "footer.planRules": "Règles du régime",
  "footer.faq": "FAQ",
  "footer.news": "Actualités",
  "footer.contactUs": "Nous joindre",
  "footer.resources": "RESSOURCES",
  "footer.annualReports": "Rapports annuels",
  "footer.newsletters": "Bulletins d'information",
  "footer.forms": "Formulaires",
  "footer.whatHappensIf": "Qu'arrive-t-il si?",
  "footer.keyPlanDefinitions": "Définitions clés du régime",
  "footer.contact": "COORDONNÉES",
  "footer.address": "200, boul. Yorkland, bureau 605\nToronto (Ontario) M2J 5C1",
  "footer.tollFree": "Sans frais : 1-888-462-6666",
  "footer.fax": "Téléc. : 416-497-4742",
  "footer.privacyPolicy": "Politique de confidentialité",
  "footer.copyright": "© {{year}} Caisse de retraite des musiciens du Canada. Tous droits réservés.",

  // ScrollToTop
  "scrollToTop": "Retour en haut",

  // Search page shared
  "search.pageLabel": "Recherche d'information",
  "search.title": "Résultats de recherche",
  "search.resultsFor": "Résultats de recherche pour :",
  "search.enterTerm": "Entrez un terme de recherche pour trouver des pages, des documents, des actualités et des FAQ.",
  "search.noQueryTitle": "Entrez un terme de recherche",
  "search.noQueryDesc": "Entrez un terme de recherche pour trouver des pages, des documents, des actualités et des FAQ.",
  "search.noResults": "Aucun résultat trouvé",
  "search.noResultsDesc": "Aucun résultat trouvé. Essayez un autre terme de recherche ou parcourez les pages FAQ et Ressources.",
  "search.browseFAQ": "Parcourir la FAQ",
  "search.browseResources": "Parcourir les ressources",
  "search.resultsCount": "{{count}} résultat",
  "search.resultsCount_plural": "{{count}} résultats",
  "search.found": "trouvés",
  "search.typePage": "Page",
  "search.typeResource": "Ressource",
  "search.typeFAQ": "FAQ",
  "search.typeNews": "Actualités",

  // Resources shared
  "resources.pageLabel": "Ressources pour les membres",
  "resources.pageTitle": "Ressources et documents",
  "resources.pageDesc": "Accédez aux documents du régime, aux formulaires, aux rapports et aux documents de référence de la Caisse de retraite des musiciens du Canada.",
  "resources.categories": "Catégories",
  "resources.selectCategory": "Sélectionner une catégorie",
  "resources.documentCount": "{{count}} document",
  "resources.documentCount_plural": "{{count}} documents",
  "resources.view": "Voir",
  "resources.open": "Ouvrir",

  // News shared
  "news.pageLabel": "Mises à jour de la Caisse",
  "news.pageTitle": "Actualités et mises à jour",
  "news.pageDesc": "Lisez les dernières annonces, avis et mises à jour de la Caisse de retraite des musiciens du Canada.",
  "news.archive": "Archives",
  "news.selectNews": "Sélectionner un article",
  "news.readAnnouncement": "Lire l'annonce",
  "news.readNotice": "Lire l'avis",
  "news.readUpdate": "Lire la mise à jour",
  "news.readMore": "Lire la suite",
  "news.readResponse": "Lire la réponse",
  "news.viewNewsletter": "Voir le bulletin",
  "news.readBackground": "Lire les renseignements généraux",

  // FAQ shared
  "faq.pageLabel": "Centre d'aide",
  "faq.pageTitle": "Foire aux questions",
  "faq.pageDesc": "Trouvez des réponses aux questions courantes sur le régime, les prestations, les cotisations, les événements de la vie et l'accès au compte membre.",
  "faq.categories": "Catégories",
  "faq.selectCategory": "Sélectionner une catégorie",
  "faq.viewPlanSummary": "Voir le résumé du régime",
  "faq.viewKeyDefinitions": "Voir les définitions clés du régime",
  "faq.emailFundOffice": "Envoyer un courriel au Bureau de la Caisse",
  "faq.accessPortal": "Accéder au portail membre",
  "faq.viewAnnualReports": "Voir les rapports annuels",
};

export default common;